<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
  		<div class="container">
			<h1>About</h1>
		</div>
	</section>
  </div>
  
  <section class="section">
	<div class="container">
		
		<div class="columns">
			
			<div class="column content main is-two-thirds">

				<h2 class="title">About us</h2>
				<p v-html="about.text" />

			</div>

			<aside class="column">
				<div class="sidebar">
					<div>
						<h4 class="subtitle">The Combined Actors of Cambridge Committee</h4>
						<p v-html="about.committeeMembers" />
						
					</div>
				</div>
			</aside>

		</div>

	</div>
  </section>
</div>
</template>

<script>
import Api from '@/config/Api'


export default {  
  data(){
    return {
      about: {}
    }
  },
  created() { 
    Api().get(`/api/about`).then(response => {
      this.about = response.data;
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    });
  },
  metaInfo: {
      title: "About",
      // titleTemplate: null // override the parent template and just use the above title only
  }
  
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/About.vue